// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"2eae9285","24":"c6e0dfa8","41":"086c2ade","322":"136a2e4e","375":"d23a61e2","622":"9b51c647","626":"03b41143"}[chunkId] + ".chunk.js";
};